var _path, _path2, _path3, _path4, _rect, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClockOrder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1556 12.0513L9.61719 5.39746",
    stroke: "#6ACFD8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9246 20.5127V10.2563C26.9241 9.80668 26.8054 9.36506 26.5804 8.97577C26.3554 8.58648 26.0319 8.26321 25.6425 8.03838L16.6682 2.91017C16.2784 2.68513 15.8362 2.56665 15.3861 2.56665C14.936 2.56665 14.4939 2.68513 14.1041 2.91017L5.12971 8.03838C4.7403 8.26321 4.41686 8.58648 4.19184 8.97577C3.96681 9.36506 3.84812 9.80668 3.84766 10.2563V20.5127C3.84812 20.9624 3.96681 21.404 4.19184 21.7933C4.41686 22.1826 4.7403 22.5059 5.12971 22.7307L14.1041 27.8589C14.4939 28.0839 14.936 28.2024 15.3861 28.2024C15.8362 28.2024 16.2784 28.0839 16.6682 27.8589L25.6425 22.7307C26.0319 22.5059 26.3554 22.1826 26.5804 21.7933C26.8054 21.404 26.9241 20.9624 26.9246 20.5127Z",
    stroke: "#6ACFD8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19141 8.9231L15.3837 15.3975L26.576 8.9231",
    stroke: "#6ACFD8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3828 28.3076V15.3845",
    stroke: "#6ACFD8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.5156,
    y: 17.25,
    width: 7.17196,
    height: 7.5,
    fill: "#DDD6F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 28C30.0902 28 33 25.0902 33 21.5C33 17.9098 30.0902 15 26.5 15C22.9098 15 20 17.9098 20 21.5C20 25.0902 22.9098 28 26.5 28ZM27.1094 21.5C27.1094 21.7031 27.0078 21.8936 26.8377 21.985L24.4002 23.61C24.1209 23.8182 23.7426 23.742 23.5775 23.4627C23.3693 23.1834 23.4455 22.8051 23.7248 22.6172L25.8906 21.175V18.0469C25.8906 17.7092 26.1623 17.4375 26.5229 17.4375C26.8377 17.4375 27.1322 17.7092 27.1322 18.0469L27.1094 21.5Z",
    fill: "#6ACFD8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOrder);
export default __webpack_public_path__ + "static/media/clock-order.a5453923.svg";
export { ForwardRef as ReactComponent };